/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTireLeftAxle40(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
      viewBox='0 0 40 40'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M28.25 22.313v2.937A1.75 1.75 0 0126.5 27h-1.375v7.75a4.75 4.75 0 01-4.75 4.75h-12a4.75 4.75 0 01-4.75-4.75V5.25A4.75 4.75 0 018.375.5h12a4.75 4.75 0 014.75 4.75V13H26.5c.966 0 1.75.784 1.75 1.75v2.938h8.125v4.625H28.25zm0-1.5v-1.625h6.625v1.625H28.25zM26.5 25.5h-1.375v-11H26.5a.25.25 0 01.25.25v10.5a.25.25 0 01-.25.25zm-2.875-2.44l-2.47 2.47a.75.75 0 11-1.06-1.06l3.53-3.53v-5.38l-2.47 2.47a.75.75 0 11-1.06-1.06l3.53-3.53V8.06l-2.47 2.47a.75.75 0 11-1.06-1.06l3.53-3.53v-.69A3.25 3.25 0 0020.375 2H17v36h3.375a3.25 3.25 0 003.25-3.25v-4.19l-2.47 2.47a.75.75 0 11-1.06-1.06l3.53-3.53v-5.38zM13.25 2h2.25v36h-2.25V2zM8.375 38h3.375V2H8.375a3.25 3.25 0 00-3.25 3.25v.69l3.53 3.53a.75.75 0 11-1.06 1.06l-2.47-2.47v5.38l3.53 3.53a.75.75 0 01-1.06 1.06l-2.47-2.47v5.38l3.53 3.53a.75.75 0 01-1.06 1.06l-2.47-2.47v5.38l3.53 3.53a.75.75 0 01-1.06 1.06l-2.47-2.47v4.19A3.25 3.25 0 008.375 38z'
        />
      </g>
      <defs>
        <clipPath id='tire-left-axle-40_svg__clip0'>
          <path fill='#fff' d='M0 0h40v40H0z' transform='rotate(90 20 20)' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgTireLeftAxle40;
